import React, { useState, useEffect } from "react";
import { Collapse } from "react-bootstrap";
import "./assets/style/Pricing.css";

const CollapsedListElem = (props) => {
  const [isVisible, initHs] = useState(false);
  const invokeCollapse = () => initHs(!isVisible);

  const colSize = props.passes.length <= 4 ? Math.floor(12 / props.passes.length) : 3;
  const colClass = `col-lg-${colSize}`;

  return (
    <li>
      <a onClick={invokeCollapse}>
        {props.title}
        <i className="bx bx-chevron-down icon-show"></i>
        <i className="bx bx-chevron-up icon-close"></i>
      </a>
      <Collapse in={isVisible}>
        <div className="collapse" data-bs-parent=".accordion-list">
          <div className="row pricing-elem">
            {props.passes.map((pass, index) => (
              <div
                className={colClass}
                data-aos="fade-up"
                data-aos-delay={`${(index + 1) * 100}`}
                key={index}
              >
                <div className={`box ${pass.featured ? 'featured' : ''}`}>
                  <h3>{pass.title}</h3>
                  <h4>
                    {pass.price}
                    <sup>zł</sup>
                  </h4>
                </div>
              </div>
            ))}
            {props.additional && (
              <div className="col-lg-12">
                <p>{props.additional}</p>
              </div>
            )}
          </div>
        </div>
      </Collapse>
    </li>
  );
};

const Pricing = () => {
  const [priceCategories, setPriceCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPriceCategories();
  }, []);

  const fetchPriceCategories = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${process.env.REACT_APP_BACKEND_ADDRESS}/price-list-categories/`);
      
      if (!response.ok) {
        throw new Error(`Failed to fetch price categories: ${response.status}`);
      }
      
      const data = await response.json();
      setPriceCategories(data.price_list_categories || []);
    } catch (error) {
      console.error('Error fetching price categories:', error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const formatPriceList = (category) => {
    const passes = [];
    
    // Add single lesson entry if available
    if (category.single_price) {
      passes.push({
        title: "Wejście jednorazowe",
        price: category.single_price.toString(),
      });
    }
    
    // Add pass types
    category.pass_types.forEach(passType => {
      passes.push({
        title: passType.name,
        price: passType.price.toString(),
      });
    });
    
    return passes;
  };

  if (loading) {
    return (
      <section id="pricing" className="pricing">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>Cennik</h2>
          </div>
          <div className="row">
            <div className="col-lg-12 pt-4 pt-lg-0 content">
              <p>Ładowanie cennika...</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section id="pricing" className="pricing">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>Cennik</h2>
          </div>
          <div className="row">
            <div className="col-lg-12 pt-4 pt-lg-0 content">
              <p>Błąd podczas ładowania cennika. Spróbuj ponownie później.</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="pricing" className="pricing">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Cennik</h2>
        </div>
        <div className="row">
          <div
            className="col-lg-12 pt-4 pt-lg-0 content"
            data-aos="fade-left"
            data-aos-delay="100"
          >
            <div className="accordion-list">
              <ul>
                {priceCategories.map((category, index) => (
                  <CollapsedListElem
                    key={category.id}
                    title={category.name}
                    passes={formatPriceList(category)}
                    additional={category.additional_info}
                  />
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
